import { useMutation } from "@tanstack/react-query";

import type { MutationConfig } from "@/lib/react-query";
import { authApi } from "@/lib/api-client";
import { apiPaths } from "@/config/paths";
import { AxiosResponse } from "axios";

type Verify2FAInput = {
  userCode: string;
};

type Verify2FAResponse = {
  success: boolean;
  redirect?: string;
};

const verify2FA = ({ data }: { data: Verify2FAInput }): Promise<AxiosResponse<Verify2FAResponse>> => {
  return authApi.post<Verify2FAInput, AxiosResponse<Verify2FAResponse>>(apiPaths.auth.verify2FA.getPath(), data);
};

type UseVerify2FAOptions = {
  mutationConfig?: MutationConfig<typeof verify2FA>;
};

export const useVerify2FA = ({ mutationConfig }: UseVerify2FAOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: verify2FA,
  });
};
